import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

const PlanChooser = () => {
	const block = document.querySelectorAll(".plan-chooser");
	if (!block) {
		return;
	}

	block.forEach((el) => {
    const items = el.querySelectorAll(".plan-chooser__list-item");
    const cards = el.querySelectorAll(".plan-chooser__card");
    const list = el.querySelector(".plan-chooser__list");
    let mm = gsap.matchMedia();
    gsap.registerPlugin(ScrollTrigger);
    const TL = gsap.timeline({
      scrollTrigger: {
        trigger: list,
        start: "top 95%",
        end: "+=50%",
        scrub: true
      }
    });

    items.forEach((item, index) => {
      mm.add("(min-width: 1024px)", () => {
        if (index === 0) {
          TL.fromTo(items[index], { y: "35%" }, { y: 0, duration: 0.4 }, 0.1);
        }
        if (index === 1) {
          TL.fromTo(items[index], { y: "25%" }, { y: 0, duration: 0.4 }, 0);
        }
        if (index === 3) {
          TL.fromTo(items[index], { y: "25%" }, { y: 0, duration: 0.4 }, 0);
        }
        if (index === 4) {
          TL.fromTo(items[index], { y: "35%" }, { y: 0, duration: 0.4 }, 0.1);
        }
      });
    });

    cards.forEach((card) => {
			card.addEventListener("mousemove", (e) => {
				const bg = card.querySelector(".plan-chooser__card-bg")
				const { x, y } = card.getBoundingClientRect();
	
				bg.style.setProperty("--x", e.clientX - x);
				bg.style.setProperty("--y", e.clientY - y);
			});
		});
	});
};

export default PlanChooser;
